import React, { useState } from "react";
import {
  Modal,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalCloseButton,
  ModalBody,
  FormControl,
  FormLabel,
  Input,
  ModalFooter,
  Button,
  Spinner,
  Text,
  Box,
  useColorMode,
} from "@chakra-ui/react";
import ReactDatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

const SendTestModal = ({
  isOpen,
  onClose,
  onSubmit,
  campaigns,
}) => {
  const [testDate, setTestDate] = useState(null);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { colorMode } = useColorMode();

  const handleSubmit = async () => {
    if (!testDate) return;

    setIsSubmitting(true);
    try {
      await onSubmit({
        processDate: testDate,
        campaigns: campaigns,
      });
    } finally {
      setIsSubmitting(false);
      setTestDate(null);
    }
  };

  const handleClose = () => {
    setTestDate(null);
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} closeOnOverlayClick={false} isCentered>
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>Select Date and Time for Test</ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Text color="gray.600">The test will be sent to the user directly.</Text>
          <Box
            p={4}
            mt={4}
            bg="gray.50"
            borderRadius="md"
            border="1px"
            borderColor="gray.200"
          >
            <FormControl>
              <FormLabel fontWeight="bold">Select Date and Time</FormLabel>
              <ReactDatePicker
                selected={testDate}
                onChange={(date) => setTestDate(date)}
                showTimeSelect
                dateFormat="Pp"
                minDate={new Date()}
                className="datepicker"
                wrapperClassName={
                  colorMode === "light" ? "light-mode" : "dark-mode"
                }
                customInput={
                  <Input
                    variant="filled"
                    bg={colorMode === "light" ? "gray.50" : "gray.700"}
                  />
                }
              />
            </FormControl>
          </Box>
        </ModalBody>
        <ModalFooter>
          <Button variant="ghost" onClick={handleClose} mr={3}>
            Cancel
          </Button>
          <Button
            colorScheme="teal"
            onClick={handleSubmit}
            isDisabled={!testDate || isSubmitting}
          >
            {isSubmitting ? <Spinner size="sm" /> : "Send"}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};

export default SendTestModal;